import { useState, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import moment from 'moment';

export function usePartnerTags(partnerClientId, dateRange) {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  const startTime = dateRange && dateRange[0] ? moment(dateRange[0]).startOf('day').valueOf() : null;
  const endTime = dateRange && dateRange[1] ? moment(dateRange[1]).endOf('day').valueOf() : null;

  useEffect(() => {
    if (!partnerClientId) {
      setTags([]);
      setLoading(false);
      return;
    }

    const db = firebase.firestore();
    let query = db.collectionGroup('tags');
    
    // If not 'all', filter by partnerClientId
    if (partnerClientId !== 'all') {
      query = query.where('partnerClientId', '==', partnerClientId);
    }

    if (startTime) {
        query = query.where('createdAt', '>=', firebase.firestore.Timestamp.fromMillis(startTime));
    }
    
    // Only apply end date filter if the end time is in the past (before today)
    // This allows real-time updates for any range that includes "today"
    const todayEnd = moment().endOf('day').valueOf();
    if (endTime && endTime < todayEnd) {
        query = query.where('createdAt', '<=', firebase.firestore.Timestamp.fromMillis(endTime));
    }

    query = query.orderBy('createdAt', 'desc');

    const unsubscribe = query.onSnapshot((snapshot) => {
      const docs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setTags(docs);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching partner tags:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [partnerClientId, startTime, endTime]);

  return [loading, tags];
}

